// extracted by mini-css-extract-plugin
export default {"header-container":"announcement-list_header-container__a6qV-","container":"announcement-list_container__05Kf5","section-container":"announcement-list_section-container__Vd+4g"};